import { render } from "./ClientDetailView.vue?vue&type=template&id=de68cca2&scoped=true"
import script from "./ClientDetailView.vue?vue&type=script&lang=js"
export * from "./ClientDetailView.vue?vue&type=script&lang=js"

import "./ClientDetailView.vue?vue&type=style&index=0&id=de68cca2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de68cca2"]])

export default __exports__